import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { Store } from '@ngrx/store';
import { AUTH_AUTO_LOGIN_RESOLVED } from '@fitness-force/state';
import { Observable, of, switchMap, filter, take } from 'rxjs';
import { AuthSevices } from '@fitness-force/api';
import { sanitizeInternalReturnUrl } from '../../utils/sanitize-return-url';


@Injectable({
    providedIn: 'root'
})
export class NoAuthGuard implements CanActivate, CanActivateChild
{
    private _authService = inject(AuthSevices);
    private _router = inject(Router);
    private store = inject(Store);


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
            return this._check(route, state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
         return this._check(childRoute, state);
    }

     private _check(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean>
     {
      return this.store.select(AUTH_AUTO_LOGIN_RESOLVED).pipe(
        filter((resolved) => resolved === true),
        take(1),
        switchMap(() => this._authService.ensureAccessTokenValid()),
        switchMap((valid) => {
          if (valid) {
            const returnUrl = route.queryParamMap.get('returnUrl');
            this._router.navigateByUrl(
              sanitizeInternalReturnUrl(
                returnUrl,
                CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION
              )
            );
            return of(false);
          }
          return of(true);
        })
      );
    }

}
